<template>
  <div
    class="navigation-item max-w-100 w-full flex items-center justify-center overflow-hidden cursor-pointer relative select-none"
    :class="{ 'rounded-t-12': selected, 'bg-primary-selected': selected }"
    @click="$emit('click', $event)"
  >
    <div class="w-14 h-14 flex justify-center items-center flex-shrink-0" v-tooltip.top="{ content: text }">
      <Icon :name="icon" class="w-6 h-6 text-[rgb(var(--color-menu-text))] flex items-center justify-center flex-shrink-0" :class="{ 'opacity-70': !selected }" />
    </div>
    <div v-if="selected" class="selected-indicator absolute w-full h-2 bg-[rgb(var(--color-menu-selected-border))] rounded-t-6" style="bottom: -5px"></div>
  </div>
</template>

<script>
export default {
  name: 'BottomNavigationItem',
  props: {
    text: String,
    icon: String,
    selected: Boolean,
  },
  emits: ['click'],
};
</script>
<style lang="scss"></style>
